<template>
  <!-- Download button for the guide pages. On a computer: one button for the
       visitor's system plus small links for the others; installer clicks open the
       next-steps panel. On phones, or before the system is known (and in the
       prerendered HTML): a button to /download, where phones get the desktop-app note. -->
  <div class="py-8 flex flex-col items-center gap-3 font-helvetica">
    <template v-if="installer">
      <a
        :href="installer.url"
        class="text-center font-bold text-white text-[18px] md:text-[20px] bg-[#262626] border-4 border-[#FF0000] rounded-full px-8 py-4 hover:underline"
        @click="clicked(platform)"
        >Download for {{ installer.label }}</a
      >
      <p class="text-[#A9A9A9] text-[14px] md:text-[15px]">
        Also for
        <template v-for="(o, i) in others" :key="o">
          <a
            :href="INSTALLERS[o].url"
            class="text-[#DDDDDD] underline hover:text-white"
            @click="clicked(o)"
            >{{ INSTALLERS[o].label }}</a
          ><span v-if="i < others.length - 1"> · </span>
        </template>
        · Free 7-day trial
      </p>
    </template>
    <template v-else>
      <router-link
        to="/download"
        class="text-center font-bold text-white text-[18px] md:text-[20px] bg-[#262626] border-4 border-[#FF0000] rounded-full px-8 py-4 hover:underline"
        >Download Rally Navigator</router-link
      >
      <p class="text-[#A9A9A9] text-[14px] md:text-[15px]">
        Windows · Mac · Linux · Free 7-day trial
      </p>
    </template>
  </div>
</template>

<script>
import { INSTALLERS, detectPlatform, downloadClicked } from '../downloads';

export default {
  name: 'GuideDownloadCta',
  data() {
    return { platform: null, INSTALLERS };
  },
  computed: {
    installer() {
      return INSTALLERS[this.platform] || null;
    },
    others() {
      return Object.keys(INSTALLERS).filter((k) => k !== this.platform);
    },
  },
  mounted() {
    this.platform = detectPlatform();
  },
  methods: {
    clicked(p) {
      downloadClicked(p, { location: 'guide' });
    },
  },
};
</script>
